import React from 'react';
import { motion } from 'framer-motion';
interface PageHeaderProps {
  title: string;
  subtitle?: string;
  backgroundImage: string;
}
export function PageHeader({
  title,
  subtitle,
  backgroundImage
}: PageHeaderProps) {
  return <div className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden" data-id="element-105">
      <div className="absolute inset-0 z-0" data-id="element-106">
        <img src={backgroundImage} alt={title} className="w-full h-full object-cover opacity-30" data-id="element-107" />
        <div className="absolute inset-0 bg-gradient-to-b from-navy-900/80 via-navy-900/90 to-navy-900" data-id="element-108"></div>
      </div>

      <div className="max-w-content mx-auto px-6 md:px-12 relative z-10 text-center" data-id="element-109">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6" data-id="element-110">
          {title}
        </motion.h1>

        {subtitle && <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="font-body text-lg md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-111">
            {subtitle}
          </motion.p>}
      </div>
    </div>;
}